<!--
    File: Lesson.vue
-->

<template>
  <v-container>
    <div class="bg" />
    <v-tabs class="pa-0 mt--15" centered>
      <v-tab class="font-14">수업안내</v-tab>
      <v-tab class="font-14" to="/booking">수업예약</v-tab>
      <v-tab class="font-14" to="/coupon">쿠폰정보</v-tab>
    </v-tabs>
    <v-list class="mt-3 pb-6">
      <v-list-item class="pa-0 mb--10" v-for="(lesson, i) in lessons" :key="i" @click="alert(lesson)">
        <v-list-item-icon>
          <v-icon>{{lesson.studio == 0 ? 'mdi-earth' : 'mdi-map-marker'}}</v-icon>
        </v-list-item-icon>
        <v-list-item-title class="ml--20" v-text="lesson.name" />
        <v-list-item-subtitle class="pl-3" v-text="lesson.content" />
      </v-list-item>
    </v-list>
    <v-footer color="transparent" padless>
      <v-col class="text-center" cols="12">© BalletFIT Korea</v-col>
    </v-footer>

    <div class="text-center" v-if="lesson">
      <v-dialog v-model="dialog" width="500">
        <v-card>
          <v-card-title>{{lesson.name}} {{lesson.studio > 0 ? ' (' + login.studio_name  + ')' : ''}}</v-card-title>
          <v-spacer class="pa-2" />
          <v-card-text class="font-14">{{lesson.content}}</v-card-text>
          <v-card-text class="font-14">{{lesson.time}}분 수업 (쿠폰 {{lesson.count}}개)</v-card-text>
          <v-divider />
          <v-card-actions>
            <v-spacer />
            <v-btn class="font-16" color="primary" text @click="dialog = false">확인</v-btn>
            <v-spacer />
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>

  </v-container>
</template>
<script>
import axios from 'axios'

export default {
  data () {
    return {
      login: null,
      lesson: null,
      lessons: [],
      dialog: false
    }
  },
  
  methods: {
    alert: function (lesson) {
      this.lesson = lesson
      this.dialog = true
    }
  },

  created () {
    console.clear()
    let json = localStorage.getItem('login')
    if (json) {
      this.login = JSON.parse(json)
    }
    if (this.login) {
      this.$emit('login', this.login)

      axios.get(`/api/lesson/list/${this.login.studio}`)
      .then(response => {
        if (response.data.error)
          console.log(response.data.error)
        else {                    
          this.lessons = response.data.list
        }
      })
    }
    else {
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
.ml--20 {
  margin-left: -20px;
}
.mt--15 {
  margin-top: -15px;
}
.mb--10 {
  margin-bottom: -10px;
}
.font-14 {
  font-size: 14px;
}
.bg-not-used {
  position: absolute;
  top: 60px;
  left: 0;
  width: 100%;
  height: 100%;
  background: url('https://cdn.imweb.me/thumbnail/20210503/60154fc8523ac.jpg') no-repeat top center;
  background-size: cover;
  opacity: 0.1;
}
</style>

<style scoped>
.font-14 {
  font-size: 14px;
}
.font-16 {
  font-size: 16px;
}
</style>